export const getEnvironment = () => {
  return {
    bugsnag: {
      token: process.env.VULN_MANAGER_UI_BUGSNAG_TOKEN ?? '',
      enable: process.env.VULN_MANAGER_UI_BUGSNAG_ENABLE?.toLowerCase().trim() === 'true',
    },
  };
};
